import React from 'react';
class AlfredSearchResults extends React.Component{

    render(){
        return(<h3>
            AlfredSearchResults
        </h3>
        
        )
    }

}
export default AlfredSearchResults